import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Collection from './components/Regions';
import RegionFeedback from './components/RegionFeedback';
import FeedbackList from './components/FeedbackList';
import FeedbackObject from './components/Zone';
import Object from './components/Region';

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, regions,roles}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/feedback_list`}>
				<FeedbackList regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/feedback`}>
				<RegionFeedback regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/zone/:id`}>
				<FeedbackObject regions={regions} baseUrl={match.url}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/:id`}>
				<Object regions={regions} baseUrl={match.url}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
